import React, { memo } from "react";
import { isEmpty } from "@swiggy-private/js-utils";
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";
import { SuperButton } from "@swiggy-private/dls-web-core/dist/components/SuperButton";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { PAYMENT_FAILURE_CONSTANTS, IMAGES } from "./constant";
import {
    Container,
    Header,
    PaymentAmountText,
    IconAndTitleContainer,
    TitleContainer,
    DescriptionContainer,
    ButtonContainer,
    TextContainer,
} from "./styled";
import { IPaymentFailureContentProps } from "./types";

const PaymentFailureContent = memo(
    ({ amount, onTryOtherMethods, paymentFailureCardData }: IPaymentFailureContentProps) => {
        return (
            <Container>
                {!isEmpty(amount) && (
                    <Header>
                        <PaymentAmountText variant="V2.body3.neutral.regular">
                            {PAYMENT_FAILURE_CONSTANTS.PAYMENT_OF} {amount}
                        </PaymentAmountText>
                    </Header>
                )}
                <IconAndTitleContainer>
                    <Image
                        cloudinaryId={paymentFailureCardData?.paymentIcon || IMAGES.PAYMENT_FAILURE}
                        alt={PAYMENT_FAILURE_CONSTANTS.IMAGE_ALT}
                        cloudinaryHeight={PAYMENT_FAILURE_CONSTANTS.ICON_HEIGHT * 2}
                        cloudinaryWidth={PAYMENT_FAILURE_CONSTANTS.ICON_WIDTH * 2}
                        height={String(PAYMENT_FAILURE_CONSTANTS.ICON_HEIGHT)}
                        width={String(PAYMENT_FAILURE_CONSTANTS.ICON_WIDTH)}
                    />

                    <TextContainer>
                        <TitleContainer>
                            <Text variant="V2.heading2.neutral.black" color="text_Highest_Emphasis">
                                {paymentFailureCardData?.title || PAYMENT_FAILURE_CONSTANTS.TITLE}
                            </Text>
                        </TitleContainer>

                        <DescriptionContainer>
                            <Text variant="V2.body2.neutral.regular" color="text_Med_Emphasis">
                                {paymentFailureCardData?.description ||
                                    PAYMENT_FAILURE_CONSTANTS.DESCRIPTION}
                            </Text>
                        </DescriptionContainer>
                    </TextContainer>
                </IconAndTitleContainer>

                <ButtonContainer>
                    <SuperButton
                        buttonType="primary"
                        buttonSize="large"
                        onClick={onTryOtherMethods}
                    >
                        {paymentFailureCardData?.buttonText ||
                            PAYMENT_FAILURE_CONSTANTS.BUTTON_TEXT}
                    </SuperButton>
                </ButtonContainer>
            </Container>
        );
    }
);

PaymentFailureContent.displayName = "PaymentFailureContent";

export default PaymentFailureContent;
